type DeliverableItem = string | { text: string };

interface DeliverablesBandProps {
  heading: string;
  items: DeliverableItem[];
}

export default function DeliverablesBand({ heading, items }: DeliverablesBandProps) {
  return (
    <div className="deliverables">
      <h3>{heading}</h3>
      <ul className="deliverables-list">
        {items.map((item) => {
          const text = typeof item === "string" ? item : item.text;
          return (
            <li key={text}>
              <span className="check">
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <polyline points="4 12 10 18 20 6" />
                </svg>
              </span>
              <span>{text}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
